<div class="section padding-top-bottom-120 section-background-rana chapter-home-nfr rana-shell-flush" id="page-top"
     xmlns="http://www.w3.org/1999/html">
    <div class="section-1400 rana-full-bleed">
        <div class="container-fluid px-0">
            <div class="row no-gutters rana-shell" id="accordionExample">
                <div class="col-lg-4 rana-shell-rail">
                    <div class="section border-4 p-3 p-xl-4 rana-nav-rail">
                        <div class="row">
                            <div class="col-12 rana-nav-brand">
                                <div class="rana-nav-brand-mark">R</div>
                                <div>
                                    <div class="rana-nav-brand-title">RANA</div>
                                    <div class="rana-nav-brand-subtitle">{{ chapter?.name }} Workspace</div>
                                </div>
                            </div>
                            <div class="col-12 d-lg-none">
                                <button type="button" class="rana-nav-mobile-toggle" data-toggle="collapse"
                                        data-target="#chapterNavRailLinks" aria-expanded="false"
                                        aria-controls="chapterNavRailLinks">
                                    <span>{{ activeSectionLabel || 'Menu' }}</span>
                                    <i class="uil uil-angle-down size-20"></i>
                                </button>
                            </div>
                            <div class="col-12 collapse d-lg-block" id="chapterNavRailLinks">

                                <div class="rana-nav-group-label">Governance</div>
                                <a href="#page-top" data-gal='m_PageScroll2id'
                                   class="btn btn-user-profile btn-fluid justify-content-start" data-toggle="collapse"
                                   data-target="#collapseOne" aria-expanded="true" aria-controls="collapseOne"
                                   (click)="setActiveSection('President Note')">
                                    <i class="uil uil-notes size-22 mr-2 pr-1"></i>
                                    President's Note
                                </a>
                                <a href="#page-top" data-gal='m_PageScroll2id'
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo"
                                   (click)="setActiveSection('Executive Committee')">
                                    <i class="uil uil-users-alt size-22 mr-2 pr-1"></i>
                                    Executive Committee
                                </a>
                                <a href="#page-top" data-gal='m_PageScroll2id'
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseBOT" aria-expanded="false" aria-controls="collapseBOT"
                                   (click)="setActiveSection('Board of Trustees')">
                                    <i class="uil uil-users-alt size-22 mr-2 pr-1"></i>
                                    Board of Trustees
                                </a>
                                <div class="rana-nav-group-label">Programs</div>
                                <a href="#page-top" data-gal='m_PageScroll2id'
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1" data-toggle="collapse"
                                   data-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree"
                                   (click)="setActiveSection('Events')">
                                    <i class="uil uil-calender size-22 mr-2 pr-1"></i>
                                    Events
                                </a>
                                <a href="#page-top" data-gal='m_PageScroll2id'
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseFour" aria-expanded="false" aria-controls="collapseFour"
                                   (click)="setActiveSection('Minutes of Meeting')">
                                    <i class="uil uil-meeting-board size-22 mr-2 pr-1"></i>
                                    Minutes of Meeting
                                </a>
                                <div class="rana-nav-group-label">Administration</div>
                                <a href="#page-top" data-gal="m_PageScroll2id"
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseStripeKeys"
                                   aria-expanded="false"
                                   aria-controls="collapseStripeKeys"
                                   *ngIf="((allChapters) && (this.userChapter === this.chapterId)) || (userRole?.COMMITTEE?.includes('CREATE') && (this.userChapter === this.chapterId))">
                                    <i class="uil uil-key-skeleton size-22 mr-2 pr-1"></i>
                                    Stripe Configuration
                                </a>

                                <a href="#page-top" data-gal="m_PageScroll2id"
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseFinance" aria-expanded="false"
                                   aria-controls="collapseFinance"
                                   *ngIf="canSeeFinance"
                                   (click)="openFinance()">
                                    <i class="uil uil-money-bill size-22 mr-2 pr-1"></i>
                                    Finance &amp; Payments
                                </a>

                                <a href="#page-top" data-gal='m_PageScroll2id'
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseUpdateUser" aria-expanded="false"
                                   aria-controls="collapseUpdateUser"
                                   *ngIf="(allChapters) && chapter?.name === 'NEC'"
                                   (click)="setActiveSection('User Profile Update')">
                                    <i class="uil uil-user-plus size-22 mr-2 pr-1"></i>
                                    User Profile Update
                                </a>

                                <a href="#page-top" data-gal='m_PageScroll2id'
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseMemberDirectory" aria-expanded="false"
                                   aria-controls="collapseMemberDirectory"
                                   (click)="openMemberDirectory()">
                                    <i class="uil uil-list-ul size-22 mr-2 pr-1"></i>
                                    Member Directory
                                </a>

                                <a href="#page-top" data-gal='m_PageScroll2id'
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseCommunication" aria-expanded="false"
                                   aria-controls="collapseCommunication"
                                   *ngIf="isChapterExecutive"
                                   (click)="openCommunicationSection()">
                                    <i class="uil uil-envelope-edit size-22 mr-2 pr-1"></i>
                                    Communication
                                </a>

                                <a href="#page-top" data-gal="m_PageScroll2id"
                                   class="btn btn-user-profile btn-fluid justify-content-start mt-1"
                                   data-toggle="collapse"
                                   data-target="#collapseDocuments" aria-expanded="false"
                                   aria-controls="collapseDocuments"
                                   *ngIf="userRole?.DOCUMENT?.includes('CREATE') || userRole?.DOCUMENT?.includes('READ')"
                                   (click)="openDocuments()">
                                    <i class="uil uil-file-upload-alt size-22 mr-2 pr-1"></i>
                                    Public Document Management
                                </a>

                                <!--a href="#page-top" data-gal='m_PageScroll2id'
                                  class="btn btn-user-profile btn-fluid justify-content-start mt-1" data-toggle="collapse"
                                  data-target="#collapseFive" aria-expanded="false" aria-controls="collapseFive">
                                  <i class="uil uil-at size-22 mr-2 pr-1"></i>
                                  Contact Us
                                </a-->
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-lg-8 mt-4 mt-lg-0 rana-shell-main">
                    <nav aria-label="breadcrumb" class="rana-shell-breadcrumb p-3 p-xl-4">
                        <ol class="breadcrumb chapter-breadcrumb mb-0">
                            <li class="breadcrumb-item">
                                <a [routerLink]="chapterRootLink">Chapters</a>
                            </li>
                            <li class="breadcrumb-item active" aria-current="page">
                                {{ chapter?.name || 'Chapter' }}
                            </li>
                            <li class="breadcrumb-item active" aria-current="page" *ngIf="activeSectionLabel">
                                {{ activeSectionLabel }}
                            </li>
                        </ol>
                    </nav>
                    <div class="section border-4 p-3 p-xl-4 rana-shell-main-inner">

                        <div id="collapseOne" class="collapse p-0 show" data-parent="#accordionExample">
                            <div class="card-body p-0">
                                <div class="row">
                                    <div class="col-12">
                                        <h5 class="mb-3">
                                            Chapter President's Note
                                        </h5>
                                        <a href="javascript:" (click)="editWelcomeNote()"
                                           *ngIf="allChapters || (userRole?.COMMITTEE?.includes('CREATE') && (this.userChapter === this.chapterId))"
                                           title="Update Welcome Note">
                                            <i class="uil uil-edit size-22 "></i>
                                        </a>

                                    </div>

                                    <div class="col-12 py-3">
                                        <div class="section divider one-dashed"></div>
                                    </div>

                                    <div *ngIf="showWelcomeNote">

                                        <app-rt-editor *ngIf="chapter" [disabled]="true"
                                                       [ngModel]="chapter.welcomeNote"></app-rt-editor>


                                    </div>
                                    <div *ngIf="!showWelcomeNote"
                                         class="section py-4 py-md-5 px-3 px-sm-4 px-lg-5 over-hide border-4 section-shadow-blue bg-white section-background-24 background-img-top form">
                                        <form [formGroup]="chapterForm" class="section nfr-form-standard">
                                            <h4 class="mb-4 text-sm-center">Add Chapter Note</h4>

                                            <div class="form-group mt-5">
                                                <app-rt-editor formControlName="welcomeNote"
                                                               [(ngModel)]="chapter.welcomeNote"
                                                               name="chapter?.welcomeNote"></app-rt-editor>
                                            </div>

                                            <div class="row mt-4">
                                                <div class="col-12 text-sm-center">
                                                    <button type="button" (click)="updateWelcomeNote()"
                                                            class="btn btn-dark-primary">
                                                        Update Chapter Note <i class="uil uil-edit size-22 ml-3"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div *ngIf="!showCommittee"
                                         class="section py-4 py-md-5 px-3 px-sm-4 px-lg-5 over-hide border-4 section-shadow-blue bg-white section-background-24 background-img-top form">
                                        <form [formGroup]="chapterForm" class="section nfr-form-standard">


                                            <div class="form-group mt-5">

                      <textarea [(ngModel)]="chapter.welcomeNote" name="chapter.welcomeNote"
                                formControlName="welcomeNote"
                                class="form-style form-textarea big gray-version no-shadow section-shadow-blue"
                                placeholder="Textarea 5 rows" autocomplete="off" rows="5"></textarea>


                                            </div>
                                            <div class="row mt-4">
                                                <div class="col-12 text-sm-center">
                                                    <button type="button" (click)="updateWelcomeNote()"
                                                            class="btn btn-dark-primary">
                                                        Update Chapter Note <i class="uil uil-edit size-22 ml-3"></i>
                                                    </button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>

                                </div>
                            </div>
                        </div>

                        <div id="collapseTwo" class="collapse p-0" data-parent="#accordionExample">

                            <app-create-committee *ngIf="activeSectionLabel === 'Executive Committee'"></app-create-committee>

                        </div>

                        <div id="collapseBOT" class="collapse p-0" data-parent="#accordionExample">

                            <app-create-bot *ngIf="activeSectionLabel === 'Board of Trustees'"></app-create-bot>

                        </div>


                        <div id="collapseThree" class="collapse p-0" data-parent="#accordionExample">
                            <app-chapter-event></app-chapter-event>
                        </div>

                        <div id="collapseFour" class="collapse p-0" data-parent="#accordionExample">
                            <app-chapter-mom></app-chapter-mom>
                        </div>

                        <div id="collapseUpdateUser" class="collapse p-0" data-parent="#accordionExample">
                            <app-update-user *ngIf="activeSectionLabel === 'User Profile Update'"></app-update-user>
                        </div>

                        <div id="collapseMemberDirectory" class="collapse p-0" data-parent="#accordionExample">
                            <div class="card-body p-0">
                                <div class="row">
                                    <div class="col-12">
                                        <div class="rana-page-header">
                                            <div>
                                                <h1 class="rana-page-title">Member Directory</h1>
                                                <p class="rana-page-subtitle" *ngIf="memberDirectoryDetailed">Contact details and full address, visible to the chapter's executive committee.</p>
                                            </div>
                                            <div>
                                                <button type="button" class="rana-action-btn mr-2"
                                                        *ngIf="memberDirectoryDetailed && filteredChapterUsers.length > 0"
                                                        (click)="exportMemberDirectoryCsv()">
                                                    Export CSV
                                                </button>
                                                <button type="button" class="rana-action-btn"
                                                        (click)="loadChapterUsers(true)">
                                                    Refresh
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-12 pb-3">
                                        <div class="section divider one-dashed"></div>
                                    </div>
                                    <div class="col-12 col-md-6 mb-3">
                                        <input class="form-control"
                                               type="text"
                                               [placeholder]="memberDirectoryDetailed ? 'Filter by name, email, phone or address' : 'Filter by name or email'"
                                               [(ngModel)]="memberSearchTerm"
                                               (ngModelChange)="applyMemberFilter()">
                                    </div>
                                    <div class="col-12">
                                        <div class="container-fluid px-2 rana-table-flat rana-div-grid member-directory-table" *ngIf="filteredChapterUsers.length > 0">

                                            <!-- Header (hidden on mobile) -->
                                            <div class="row d-none d-md-flex rana-div-table-header">
                                                <div [class.col-md-3]="memberDirectoryDetailed" [class.col-md-5]="!memberDirectoryDetailed">Member</div>
                                                <ng-container *ngIf="memberDirectoryDetailed">
                                                    <div class="col-md-3">Email</div>
                                                    <div class="col-md-2">Phone</div>
                                                    <div class="col-md-2">Address</div>
                                                </ng-container>
                                                <div class="col-md-4" *ngIf="!memberDirectoryDetailed">City</div>
                                                <div [class.col-md-2]="memberDirectoryDetailed" [class.col-md-3]="!memberDirectoryDetailed">Membership</div>
                                            </div>

                                            <!-- Rows -->
                                            <div class="row border-bottom align-items-center rana-div-table-row" *ngFor="let user of filteredChapterUsers">
                                                <div class="col-12" [class.col-md-3]="memberDirectoryDetailed" [class.col-md-5]="!memberDirectoryDetailed">
                                                    <a href="#page-top"
                                                       data-gal='m_PageScroll2id'
                                                       data-toggle="collapse"
                                                       data-target="#collapseMemberLookup"
                                                       aria-controls="collapseMemberLookup"
                                                       class="rana-member-link"
                                                       (click)="openMemberLookup(user)">
                                                        <div class="rana-avatar">{{ memberInitials(user) }}</div>
                                                        <span class="fw-semibold">{{ user.firstname }} {{ user.lastname }}</span>
                                                    </a>
                                                </div>
                                                <ng-container *ngIf="memberDirectoryDetailed">
                                                    <div class="col-12 col-md-3">
                                                        <span class="d-md-none fw-semibold">Email: </span>
                                                        <a *ngIf="user.email" href="mailto:{{ user.email }}">{{ user.email }}</a>
                                                        <span *ngIf="!user.email">N/A</span>
                                                    </div>
                                                    <div class="col-12 col-md-2 text-nowrap">
                                                        <span class="d-md-none fw-semibold">Phone: </span>
                                                        <a *ngIf="user.phone" href="tel:{{ user.phone }}">{{ user.phone }}</a>
                                                        <span *ngIf="!user.phone">N/A</span>
                                                    </div>
                                                    <div class="col-12 col-md-2">
                                                        <span class="d-md-none fw-semibold">Address: </span>{{ formatMemberAddress(user) || 'N/A' }}
                                                    </div>
                                                </ng-container>
                                                <div class="col-12 col-md-4" *ngIf="!memberDirectoryDetailed">
                                                    <span class="d-md-none fw-semibold">City: </span>{{ user.city || 'N/A' }}
                                                </div>
                                                <div class="col-12" [class.col-md-2]="memberDirectoryDetailed" [class.col-md-3]="!memberDirectoryDetailed">
                                                    <span class="d-md-none fw-semibold">Membership: </span>
                                                    <span class="rana-badge"
                                                          [ngClass]="isPaidMember(user) ? 'rana-badge-success' : 'rana-badge-neutral'">
                                                        {{ getMembershipLabel(user.memberType) }}
                                                    </span>
                                                </div>
                                            </div>
                                        </div>
                                        <p class="text-muted mb-0" *ngIf="memberDirectoryLoaded && filteredChapterUsers.length === 0">
                                            No members found for this chapter filter.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="collapseMemberLookup" class="collapse p-0" data-parent="#accordionExample">
                            <app-user-card [loadOnInit]="false"
                                           [chapterScopeId]="chapterId"
                                           [users]="chapterUsers"
                                           [initialSelectedUserId]="selectedDirectoryUserId">
                            </app-user-card>
                        </div>

                        <div id="collapseCommunication" class="collapse p-0" data-parent="#accordionExample" *ngIf="isChapterExecutive">
                            <div class="card-body p-0">
                                <h5 class="mb-3">Chapter / NEC Communication</h5>
                                <div class="col-12 pb-3">
                                    <div class="section divider one-dashed"></div>
                                </div>

                                <form [formGroup]="communicationForm" class="nfr-form-standard">
                                    <div class="form-group mb-3">
                                        <label>Audience Scope</label>
                                        <select class="form-control"
                                                formControlName="scope"
                                                (change)="onCommunicationScopeChange()">
                                            <option *ngFor="let option of communicationScopeOptions"
                                                    [value]="option.value">
                                                {{ option.label }}
                                            </option>
                                        </select>
                                    </div>

                                    <div class="form-group mb-3" *ngIf="communicationForm.value.scope === 'SPECIFIC_CHAPTERS' && isNecExecutive">
                                        <label>Select Chapters</label>
                                        <select class="form-control" formControlName="chapterIds" multiple>
                                            <option *ngFor="let chapterItem of chapterList"
                                                    [value]="chapterItem.id"
                                                    [hidden]="chapterItem.id === '0'">
                                                {{ chapterItem.name }}
                                            </option>
                                        </select>
                                        <small class="text-muted">Hold Ctrl/Cmd to select multiple chapters.</small>
                                    </div>

                                    <div class="form-group form-check mb-3">
                                        <input type="checkbox"
                                               class="form-check-input"
                                               id="includeNonMembers"
                                               formControlName="includeNonMembers">
                                        <label class="form-check-label" for="includeNonMembers">
                                            Include non-members
                                        </label>
                                    </div>

                                    <div class="form-group mb-3">
                                        <label>Subject</label>
                                        <input type="text" class="form-control" formControlName="subject">
                                    </div>

                                    <div class="form-group mb-3">
                                        <label>Message</label>
                                        <textarea rows="6" class="form-control" formControlName="body"></textarea>
                                    </div>

                                    <div class="text-right">
                                        <button type="button"
                                                class="btn btn-dark-primary"
                                                [disabled]="sendingCommunication"
                                                (click)="sendChapterCommunication()">
                                            {{ sendingCommunication ? 'Sending...' : 'Send Communication' }}
                                        </button>
                                    </div>
                                </form>

                                <div class="alert alert-success mt-3" *ngIf="communicationResult">
                                    Delivered: {{ communicationResult.deliveredCount }} |
                                    Failed: {{ communicationResult.failedCount }}
                                </div>

                                <div class="mt-4">
                                    <div class="d-flex justify-content-between align-items-center mb-2">
                                        <h6 class="mb-0">Communication History</h6>
                                        <button type="button"
                                                class="btn btn-sm btn-outline-secondary"
                                                (click)="openCommunicationSection()">
                                            Refresh
                                        </button>
                                    </div>
                                    <div class="text-muted small mb-2" *ngIf="loadingCommunicationHistory">Loading communication history...</div>
                                    <div class="table-responsive">
                                      <div class="rana-table-flat">
                                        <table datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table rana-table">
                                            <thead>
                                            <tr>
                                                <th>Sent Date</th>
                                                <th>Subject</th>
                                                <th>Scope</th>
                                                <th>Delivered</th>
                                                <th>Failed</th>
                                            </tr>
                                            </thead>
                                            <tbody></tbody>
                                        </table>
                                      </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div id="collapseDocuments" class="collapse p-0" data-parent="#accordionExample">
                            <app-admin-documents *ngIf="documentsOpened" [embedded]="true"></app-admin-documents>
                        </div>

                        <div id="collapseFinance" class="collapse p-0" data-parent="#accordionExample">
                            <ng-container *ngIf="financeOpened && canSeeFinance">
                                <ng-container *ngFor="let k of [chapterId]">
                                    <app-finance [embedded]="true" [initialChapter]="financeQueryParams['chapter'] || ''"></app-finance>
                                </ng-container>
                            </ng-container>
                        </div>

                        <div id="collapseStripeKeys" class="collapse p-0" data-parent="#accordionExample">
                                   <h5 class="mb-4 text-center">Stripe Keys Configuration</h5>

                                    <form [formGroup]="stripeForm" class="nfr-form-standard">
                                        <div class="form-group">
                                            <label>Configure Keys For</label>
                                            <select class="form-control" formControlName="stripeTarget" (change)="onStripeTargetChange()">
                                                <option [value]="DEFAULT_STRIPE_TARGET">Default (chapter-wide)</option>
                                                <option *ngFor="let evt of chapterEvents" [value]="evt.id">{{ evt.title }}</option>
                                            </select>
                                            <small class="text-muted d-block mt-1">
                                                <span *ngIf="stripeForm.get('stripeTarget')?.value === DEFAULT_STRIPE_TARGET">
                                                    <span *ngIf="chapter?.stripeEnabled" class="text-success">Default keys are configured.</span>
                                                    <span *ngIf="!chapter?.stripeEnabled">Default keys are not yet configured.</span>
                                                </span>
                                                <span *ngIf="stripeForm.get('stripeTarget')?.value !== DEFAULT_STRIPE_TARGET">
                                                    <span *ngIf="selectedStripeEvent?.hasCustomStripeKeys" class="text-success">Custom Stripe account configured for this event.</span>
                                                    <span *ngIf="!selectedStripeEvent?.hasCustomStripeKeys">Using the chapter's default Stripe account.</span>
                                                </span>
                                            </small>
                                        </div>

                                        <div class="form-group">
                                            <label>Stripe Public Key</label>
                                            <input type="text"
                                                   class="form-control"
                                                   formControlName="stripePublicKey"
                                                   placeholder="pk_live_..." />
                                        </div>

                                        <div class="form-group mt-3">
                                            <label>Stripe Secret Key</label>
                                            <input type="password"
                                                   class="form-control"
                                                   formControlName="stripeSecretKey"
                                                   placeholder="sk_live_..." />
                                        </div>

                                        <div class="text-center mt-4">
                                            <button type="button"
                                                    class="btn btn-dark-primary"
                                                    (click)="updateStripeKeys()">
                                                Update Stripe Keys
                                                <i class="uil uil-lock size-20 ml-2"></i>
                                            </button>
                                        </div>
                                    </form>
                                </div>



                        <div id="collapseFive" class="collapse p-0" data-parent="#accordionExample">
                            <div class="card-body p-0">
                                <div class="row">
                                    <div class="row justify-content-center">
                                        <div class="col-12 align-self-center text-center mb-5 pb-lg-3">
                                            <h6 class="color-primary text-uppercase mb-2">
                                                contact
                                            </h6>
                                            <h3 class="display-8 mb-4 color-gray-dark">
                                                Please post your question below
                                            </h3>

                                        </div>
                                        <div class="col-xl-8">
                                            <div class="form-group mx-auto text-center">

                                            </div>
                                        </div>
                                        <div class="clearfix w-100"></div>
                                        <div class="col-md-6 col-xl-4 mt-4">
                                            <div class="form-group">
                                                <input type="text" name="contactname"
                                                       class="form-style big form-style-with-icon section-shadow-blue"
                                                       placeholder="Nirbhay singh"
                                                       disabled id="contactname" autocomplete="off">
                                                <i class="input-icon big uil uil-user"></i>
                                            </div>
                                        </div>
                                        <div class="col-md-6 col-xl-4 mt-4">
                                            <div class="form-group">
                                                <input type="email" name="contactemail"
                                                       class="form-style big form-style-with-icon section-shadow-blue"
                                                       placeholder="nirbhaykr.singh@gmail.com" disabled
                                                       id="contactemail" autocomplete="off">
                                                <i class="input-icon big uil uil-at"></i>
                                            </div>
                                        </div>
                                        <div class="clearfix w-100"></div>
                                        <div class="col-xl-8 mt-4">
                                            <div class="form-group">
                        <textarea name="contactmessage"
                                  class="form-style big form-style-with-icon form-textarea section-shadow-blue"
                                  placeholder="Message" id="contactmessage" autocomplete="off" rows="5"></textarea>
                                                <i class="input-icon big uil uil-comment-alt-lines"></i>
                                            </div>

                                        </div>

                                        <div class="col-12 text-center pt-5">
                                            <p id="contact-message-feedback"></p>
                                            <button type="button" class="btn btn-dark-primary send-contact-message"
                                                    data-toggle="modal"
                                                    data-target="#modal-contact-us">Send message<i
                                                    class="uil uil-arrow-right size-22 ml-3"></i></button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>




    <div class="modal fade modal-small" id="modal-contact-us" tabindex="-1" role="dialog" aria-labelledby="modal-1"
         aria-hidden="true">
        <div class="modal-dialog " role="document">
            <div class="modal-content section-background-13">
                <div class="modal-body z-bigger">
                    <div class="container-fluid ">
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <i class="uil uil-multiply"></i>
                        </button>
                        <div class="row justify-content-center">

                            <div class="col-12 text-center">
                                <h5 class="mb-3">Thanks for the message!</h5>
                            </div>
                            <div class="col-12 text-center">
                                <p class="mb-0">A message has been sent to Arizona chapter executive committee. They
                                    will reach out you
                                    at earliest convenience.</p>
                            </div>
                            <div class="col-12 text-center mt-5">
                                <button data-dismiss="modal" type="button" class="btn btn-dark">Thanks</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


  


